import request from "../helpers/request";
import {createRestfulApi} from "./createRestfulApi";

const URL = {
    // 目录管理
    GETCLASSTREE: "classTree/getClassTree",
    SAVECLASSTREE: "classTree/saveClassTree",
    DELETECLASSTREE: "classTree/deleteClassTree",

    // 标签
    GETTAGVALUELIST: "tag/getTagValueList",
    SAVETAGVALUE: "tag/saveTagValue",
    DELETETAGVALUE: "tag/deleteTagValue",
    // 标签分类
    GETTAGCATEGORLIST: "tag/getTagCategoryList",
    SAVETAGCATEGOR: "tag/saveTagCategory",
    DELETETAGCATEGORY: "tag/deleteTagCategory",

    // 系列管理
    GETCLASSSUBJECTLIST: "classSubject/getClassSubjectList",
    SAVECLASSSUBJECT: "classSubject/saveClassSubject",
    DELETECLASSSUBJECT: "classSubject/deleteClassSubject",
    DEPLOYCLASSSUBJECT: "classSubject/deployClassSubject",

    // 审批管理
    GETLESSONVERIFYRESPONSELIST: "lesson/getLessonVerifyResponseList",
    VERIFYLESSONVERSION: "lesson/verifyLessonVersion",
    DEPLOYLESSON: "lesson/deployLesson",

    // 课包分类
    GET_PRODUCT_CATEGORY_LIST: "product/getProductCategoryList",
    SAVE_PRODUCT_CATEGORY: "product/saveProductCategory",
    DELETE_PRODUCT_CATEGORY: "product/deleteProductCategory",
    DEPLOY_PRODUCT_CATEGORY: "product/deployProductCategory",
    MOVE_PRODUCT_CATEGORY: "product/moveProductCategory",

    // 课程包管理
    GETPRODUCTRESPONSELIST: "product/getProductResponseList",
    MOVEPRODUCT: "product/moveProduct",
    SAVEPRODUCTION: "product/saveProduct",
    DEPLOYPRODUCT: "product/deployProduct",
    DELETEPRODUCT: "product/deleteProduct",
    GETCLASSSUBJECTINFOLIST: "classSubject/getClassSubjectInfoList",
    GETLESSONUPPERPASSRESPONSELIST: "lesson/getLessonUpperPassResponseList",
    //保存自定义系列内容
    SAVECUSTOMSUBJECT: "product/saveCustomSubject",
    // 保存并发布课包
    SAVEPRODUCTAUTOUP: "/product/saveProductAutoUp",
    //   系列内容列表
    GETPRODUCTSUBJECTCONTENTLIST: "product/getProductSubjectContentList",
    SAVECUSTOMSUBJECTMIRROR: "product/saveCustomSubjectMirror",
};

export default {
    getClassTree({parentId}) {
        return request(URL.GETCLASSTREE, "POST", {
            parentId,
        });
    },
    saveClassTree({id, name, parentId}) {
        return request(URL.SAVECLASSTREE, "POST", {
            id,
            name,
            parentId,
        });
    },
    deleteClassTree({id}) {
        return request(URL.DELETECLASSTREE, "POST", {id});
    },
    getClassSubjectList: createRestfulApi(URL.GETCLASSSUBJECTLIST, {
        queryParams: [],
    }),
    getClassSubjectInfoList: createRestfulApi(URL.GETCLASSSUBJECTINFOLIST, {
        queryParams: [],
    }),
    saveClassSubject({id, classTreeId, material, materialId, name, tags, userId}) {
        return request(URL.SAVECLASSSUBJECT, "POST", {
            id,
            classTreeId,
            material,
            materialId,
            name,
            tags,
            // tenantDepartmentId,
            userId,
        });
    },
    deleteClassSubject({id}) {
        return request(URL.DELETECLASSSUBJECT, "POST", {id});
    },
    deployClassSubject({id, states}) {
        return request(URL.DEPLOYCLASSSUBJECT, "POST", {id, states});
    },
    getLessonVerifyResponseList: createRestfulApi(
        URL.GETLESSONVERIFYRESPONSELIST,
        {
            queryParams: [],
        }
    ),
    verifyLessonVersion({comment, lessonId, states, version}) {
        return request(URL.VERIFYLESSONVERSION, "POST", {
            comment,
            lessonId,
            states,
            version,
        });
    },
    deployLesson({deployStates, id, version}) {
        return request(URL.DEPLOYLESSON, "POST", {
            deployStates,
            id,
            version,
        });
    },
    getProductCategoryList(params) {
        return request(URL.GET_PRODUCT_CATEGORY_LIST, "POST", params);
    },
    saveProductCategory(params) {
        return request(URL.SAVE_PRODUCT_CATEGORY, "POST", params);
    },
    deleteProductCategory(id) {
        return request(URL.DELETE_PRODUCT_CATEGORY, "POST", {id});
    },
    deployProductCategory(id) {
        return request(URL.DEPLOY_PRODUCT_CATEGORY, "POST", {id});
    },
    moveProductCategory(params) {
        return request(URL.MOVE_PRODUCT_CATEGORY, "POST", params);
    },
    getProductResponseList: createRestfulApi(URL.GETPRODUCTRESPONSELIST, {
        queryParams: [],
    }),
    moveProduct(params) {
        return request(URL.MOVEPRODUCT, "POST", params);
    },
    saveProduct({
                    id,
                    allowable,
                    category,
                    type,
                    description,
                    imageList,
                    introduce,
                    name,
                    nicknames,
                    paymentMethod,
                    materialUrl,
                    productSubjects,
                    salePrice,
                    text,
                    total,
                    validityType,
                    discount,
                    groupPurchase,
                    groupPurchaseDataList,
                    tagValueIdList,
                    commercial,
                    buyOutPrice
                }) {
        return request(URL.SAVEPRODUCTION, "POST", {
            id,
            allowable,
            category,
            type,
            description,
            imageList,
            introduce,
            name,
            nicknames,
            paymentMethod,
            materialUrl,
            productSubjects,
            salePrice,
            text,
            total,
            validityType,
            discount,
            groupPurchase,
            groupPurchaseDataList,
            tagValueIdList,
            commercial,
            buyOutPrice
        });
    },
    saveProductAutoUp({
                          id,
                          allowable,
                          category,
                          type,
                          description,
                          imageList,
                          introduce,
                          name,
                          nicknames,
                          paymentMethod,
                          materialUrl,
                          productSubjects,
                          salePrice,
                          text,
                          total,
                          validityType,
                          discount,
                          groupPurchase,
                          groupPurchaseDataList,
                          tagValueIdList,
                          commercial,
                          buyOutPrice
                      }) {
        return request(URL.SAVEPRODUCTAUTOUP, "POST", {
            id,
            allowable,
            category,
            type,
            description,
            imageList,
            introduce,
            name,
            nicknames,
            paymentMethod,
            materialUrl,
            productSubjects,
            salePrice,
            text,
            total,
            validityType,
            discount,
            groupPurchase,
            groupPurchaseDataList,
            tagValueIdList,
            commercial,
            buyOutPrice
        });
    },
    deployProduct({id, states}) {
        return request(URL.DEPLOYPRODUCT, "POST", {
            id,
            states,
        });
    },
    deleteProduct({id}) {
        return request(URL.DELETEPRODUCT, "POST", {
            id,
        });
    },
    getLessonUpperPassResponseList: createRestfulApi(
        URL.GETLESSONUPPERPASSRESPONSELIST,
        {
            queryParams: [],
        }
    ),
    saveCustomSubject({classSubjectName, lessonIdList, type}) {
        return request(URL.SAVECUSTOMSUBJECT, "POST", {
            classSubjectName,
            lessonIdList,
            type,
        });
    },
    getProductSubjectContentList: createRestfulApi(
        URL.GETPRODUCTSUBJECTCONTENTLIST,
        {
            queryParams: [],
        }
    ),
    saveCustomSubjectMirror({id, lessonIdList, mirrorNo, type}) {
        return request(URL.SAVECUSTOMSUBJECTMIRROR, "POST", {
            id,
            lessonIdList,
            mirrorNo,
            type,
        });
    },
    getTagValueList: createRestfulApi(URL.GETTAGVALUELIST, {
        queryParams: [],
    }),
    saveTagValue({id, name, tagCategoryId}) {
        return request(URL.SAVETAGVALUE, "POST", {
            id,
            name,
            tagCategoryId,
        });
    },
    deleteTagValue({id}) {
        return request(URL.DELETETAGVALUE, "POST", {
            id,
        });
    },
    getTagCategoryList: createRestfulApi(URL.GETTAGCATEGORLIST, {
        queryParams: [],
    }),
    saveTagCategory({id, name}) {
        return request(URL.SAVETAGCATEGOR, "POST", {
            id,
            name,
        });
    },
    deleteTagCategory({id}) {
        return request(URL.DELETETAGCATEGORY, "POST", {
            id,
        });
    },
};
